import React from "react";
import Carrusel from "react-material-ui-carousel";

export function CarruselStyled(props) {
  const { children, ...property } = props;

  return <Carrusel {...property}>{children}</Carrusel>;
}
